var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "npvContainer" },
    [
      _c("v-card", { staticClass: "card" }, [
        _c("div", { staticClass: "headerContainer" }, [
          _c("span", { staticClass: "headerTitle" }, [_vm._v("Simulations")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "actionsTitleContainer" },
            [
              _c("v-text-field", {
                staticClass: "layer-search",
                attrs: {
                  "prepend-inner-icon": "search",
                  label: _vm.$t("Search"),
                  placeholder: _vm.$t("Search"),
                  "single-line": ""
                },
                model: {
                  value: _vm.search,
                  callback: function($$v) {
                    _vm.search = $$v
                  },
                  expression: "search"
                }
              }),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "addSimulationButton",
                  on: { click: _vm.addSimulationHandler }
                },
                [
                  _c("v-icon", { attrs: { left: "" } }, [_vm._v(" mdi-plus ")]),
                  _vm._v("\n          Add Simulation\n        ")
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tableContainer" },
          [
            _c("v-data-table", {
              class: {
                "no-show-permission": !_vm.userHasPermissionTo("show")
              },
              attrs: {
                headers: _vm.headersT,
                items: _vm.simulations,
                search: _vm.search,
                loading: _vm.loading,
                "loading-text": "",
                page: _vm.paginationWeb.page,
                "sort-by": _vm.paginationWeb.sortBy,
                "sort-desc": _vm.paginationWeb.descending,
                "items-per-page": _vm.paginationWeb.rowsPerPage,
                "items-per-page-text": _vm.rowsPerPageText,
                "items-per-page-items": _vm.rowsPerPageItems,
                "header-props": { sortIcon: _vm.sortIcon },
                "footer-props": {
                  prevIcon: _vm.prevIcon,
                  nextIcon: _vm.nextIcon,
                  "items-per-page-options": _vm.rowsPerPageItems
                },
                "hide-default-header": ""
              },
              on: {
                "update:page": function($event) {
                  return _vm.$set(_vm.paginationWeb, "page", $event)
                },
                "update:itemsPerPage": function($event) {
                  return _vm.$set(_vm.paginationWeb, "rowsPerPage", $event)
                },
                "update:items-per-page": function($event) {
                  return _vm.$set(_vm.paginationWeb, "rowsPerPage", $event)
                },
                pagination: function($event) {
                  return _vm.loadingSpinners(
                    _vm.dataTableUserWebListId,
                    _vm.paginationWeb.rowsPerPage
                  )
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "header",
                  fn: function() {
                    return [
                      _c("thead", [
                        _c(
                          "tr",
                          [
                            _c(
                              "table-header-cell",
                              {
                                staticStyle: {
                                  "padding-left": "39px",
                                  "background-color":
                                    "rgba(103, 160, 180, 0.15)"
                                },
                                attrs: {
                                  header: _vm.mainHeadersWeb[0],
                                  filterActive: !!_vm.filters.name,
                                  pagination: _vm.paginationWeb,
                                  "sort-icon":
                                    _vm.paginationWeb.descending &&
                                    _vm.mainHeadersWeb[0].value ===
                                      _vm.paginationWeb.sortBy
                                      ? "arrow_drop_up"
                                      : "arrow_drop_down"
                                },
                                on: { sort: _vm.changeSort }
                              },
                              [
                                _c("v-text-field", {
                                  staticClass: "text-field",
                                  attrs: { label: "Label", clearable: "" },
                                  model: {
                                    value: _vm.filters.label,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filters, "label", $$v)
                                    },
                                    expression: "filters.label"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "table-header-cell",
                              {
                                staticStyle: {
                                  "background-color":
                                    "rgba(103, 160, 180, 0.15)"
                                },
                                attrs: {
                                  header: _vm.mainHeadersWeb[1],
                                  pagination: _vm.paginationWeb,
                                  filterActive: !!_vm.filters.username,
                                  "sort-icon":
                                    _vm.paginationWeb.descending &&
                                    _vm.mainHeadersWeb[1].value ===
                                      _vm.paginationWeb.sortBy
                                      ? "arrow_drop_up"
                                      : "arrow_drop_down"
                                },
                                on: { sort: _vm.changeSort }
                              },
                              [
                                _c("v-text-field", {
                                  staticClass: "text-field",
                                  attrs: { label: "Workspace", clearable: "" },
                                  model: {
                                    value: _vm.filters.workspace,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filters, "workspace", $$v)
                                    },
                                    expression: "filters.workspace"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "table-header-cell",
                              {
                                staticStyle: {
                                  "background-color":
                                    "rgba(103, 160, 180, 0.15)"
                                },
                                attrs: {
                                  header: _vm.mainHeadersWeb[2],
                                  pagination: _vm.paginationWeb,
                                  filterActive: !!_vm.filters.email,
                                  "sort-icon":
                                    _vm.paginationWeb.descending &&
                                    _vm.mainHeadersWeb[2].value ===
                                      _vm.paginationWeb.sortBy
                                      ? "arrow_drop_up"
                                      : "arrow_drop_down"
                                },
                                on: { sort: _vm.changeSort }
                              },
                              [
                                _c("v-text-field", {
                                  staticClass: "text-field",
                                  attrs: { label: "User", clearable: "" },
                                  model: {
                                    value: _vm.filters.email,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filters, "email", $$v)
                                    },
                                    expression: "filters.email"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "table-header-cell",
                              {
                                staticStyle: {
                                  "background-color":
                                    "rgba(103, 160, 180, 0.15)"
                                },
                                attrs: {
                                  header: _vm.mainHeadersWeb[3],
                                  pagination: _vm.paginationWeb,
                                  filterActive: !!_vm.filters.status,
                                  "sort-icon":
                                    _vm.paginationWeb.descending &&
                                    _vm.mainHeadersWeb[3].value ===
                                      _vm.paginationWeb.sortBy
                                      ? "arrow_drop_up"
                                      : "arrow_drop_down"
                                },
                                on: { sort: _vm.changeSort }
                              },
                              [
                                _c("v-text-field", {
                                  staticClass: "text-field",
                                  attrs: {
                                    label: "Last Updated",
                                    clearable: ""
                                  },
                                  model: {
                                    value: _vm.filters.lastUpdated,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filters, "lastUpdated", $$v)
                                    },
                                    expression: "filters.lastUpdated"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "table-header-cell",
                              {
                                staticStyle: {
                                  "background-color":
                                    "rgba(103, 160, 180, 0.15)"
                                },
                                attrs: {
                                  header: _vm.mainHeadersWeb[4],
                                  pagination: _vm.paginationWeb,
                                  filterActive: false,
                                  "sort-icon":
                                    _vm.paginationWeb.descending &&
                                    _vm.mainHeadersWeb[3].value ===
                                      _vm.paginationWeb.sortBy
                                      ? "arrow_drop_up"
                                      : "arrow_drop_down"
                                },
                                on: { sort: _vm.changeSort }
                              },
                              [
                                _c("v-text-field", {
                                  staticClass: "text-field",
                                  attrs: { label: "Status", clearable: "" },
                                  model: {
                                    value: _vm.filters.status,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filters, "status", $$v)
                                    },
                                    expression: "filters.status"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("table-header-cell", {
                              staticStyle: {
                                "padding-left": "20px",
                                "background-color": "rgba(103, 160, 180, 0.15)"
                              },
                              attrs: {
                                header: _vm.mainHeadersWeb[5],
                                pagination: _vm.paginationWeb,
                                filterActive: false,
                                "sort-icon": ""
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]
                  },
                  proxy: true
                },
                {
                  key: "item",
                  fn: function(props) {
                    return [
                      _c(
                        "tr",
                        {
                          class: {
                            "cursor-pointer": _vm.userHasPermissionTo("show")
                          },
                          on: {
                            click: function($event) {
                              return _vm.viewItem(props.item)
                            }
                          }
                        },
                        [
                          _c("td", [_vm._v(_vm._s(props.item.smlr_id))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(props.item.workspace_name))]),
                          _vm._v(" "),
                          _c(
                            "td",
                            [
                              _c(
                                "v-icon",
                                {
                                  staticStyle: { "margin-right": "12px" },
                                  attrs: { color: "#4FA2B7" }
                                },
                                [_vm._v("mdi-account")]
                              ),
                              _vm._v(
                                _vm._s(props.item.user_name) + "\n            "
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(_vm._s(props.item.smlr_updated_at))
                          ]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(props.item.smlr_status))]),
                          _vm._v(" "),
                          _vm.userCanEditOrRemoveItems
                            ? _c(
                                "td",
                                [
                                  _c("app-datatable-action-buttons", {
                                    attrs: {
                                      "user-can-delete": _vm.isSuperAdmin,
                                      "user-can-workspace":
                                        _vm.superAdminAndAdminPermission
                                    },
                                    on: {
                                      delete: function($event) {
                                        return _vm.askConfirmationToDeleteItem(
                                          props.item
                                        )
                                      },
                                      workspace: function($event) {
                                        return _vm.openWorkspace(props.item)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      )
                    ]
                  }
                },
                {
                  key: "pageText",
                  fn: function(props) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(props.pageStart) +
                          " - " +
                          _vm._s(props.pageStop) +
                          " " +
                          _vm._s(_vm.$t("tables.Of")) +
                          "\n          " +
                          _vm._s(props.itemsLength) +
                          "\n        "
                      )
                    ]
                  }
                },
                {
                  key: "no-results",
                  fn: function() {
                    return [
                      _c("data-table-no-results", {
                        attrs: { search: _vm.search }
                      })
                    ]
                  },
                  proxy: true
                },
                {
                  key: "no-data",
                  fn: function() {
                    return [
                      _vm.loading
                        ? _c("div")
                        : _c(
                            "v-alert",
                            {
                              staticClass: "data-table-no-data",
                              attrs: { icon: "warning" }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("NoDataWeb")) +
                                  "\n          "
                              )
                            ]
                          )
                    ]
                  },
                  proxy: true
                }
              ])
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.isWorkspaceDialogOpen
        ? _c("select-workspace-dialog-box", {
            staticStyle: { "z-index": "10" },
            attrs: {
              "workspace-options": _vm.simulationWorkspacesOptions,
              workspaces: _vm.simulationWorkspaces
            },
            on: {
              close: _vm.closeSelectWorkspaceDialogBox,
              confirm: _vm.openOnWorkspace
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("app-dialog-box", {
        attrs: {
          open: _vm.isDialogOpen,
          title: _vm.$t("DeleteSimulation"),
          content: _vm.$t("DeleteSimulationMessage"),
          "main-action-label": _vm.$t("Yes"),
          "secondary-action-label": _vm.$t("Cancel")
        },
        on: {
          mainAction: _vm.deleteSimulation,
          secondaryAction: function($event) {
            _vm.isDialogOpen = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dccdf076", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dccdf076","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Npv/NpvTable.vue
// module id = null
// module chunks = 